import React from "react";
import { createRoot } from "react-dom/client";
import Customers from "./Customers";

declare global {
	interface Window {
		renderCustomersPage: unknown;
	}
}

export function renderCustomersPage(rootId: string) {
	const root = createRoot(document.getElementById(rootId)!);
	root.render(<Customers />);
}

window.renderCustomersPage = renderCustomersPage;
